
import { COMMA, ENTER, SEMICOLON, SPACE } from '@angular/cdk/keycodes';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { NGXLogger } from 'ngx-logger';
import { from, ReplaySubject, Subject } from 'rxjs';
import { concatMap, debounceTime, delay, distinctUntilChanged, map, startWith, takeUntil } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { DataService } from 'src/app/shared/services/data.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { IDocumentCriteria, IEntityGroup, IEnum } from '../external-entity.interface';
import * as _ from "underscore"; 
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AddressConfig } from 'src/app/shared/components/address/address-config.model';
import { MatDialog } from '@angular/material/dialog';
import { ViewLinkedCompaniesComponent } from '../view-linked-companies/view-linked-companies.component';
import { AddressComponent } from 'src/app/shared/components/address/address.component';
import { CreditTermsComponent } from '../credit-terms/credit-terms.component';
import { ExternalEntityService } from '../external-entity.service';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { AuditLogTab, ICurrency, IPermissionWithShow } from 'src/app/shared/interface';
import { tap } from 'rxjs/operators';
import { CustomValidator } from 'src/app/shared/validators/custom-validator';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { GroupDetailFormComponent } from '../group-detail-form/group-detail-form.component';
import { IEmployee } from 'src/app/user-management/employee/employee.interface';
import { KycDetailsComponent } from '../kyc-details/kyc-details.component';
import { EntityBranchFormComponent } from '../entity-branch-form/entity-branch-form.component';
import { Message } from 'src/app/shared/constants/message';
import { ToastrService } from 'ngx-toastr';
import { DocumentPreviewDialogComponent } from '../document-preview-dialog/document-preview-dialog.component';

@Component({
    selector: 'app-entity-form',
    templateUrl: './entity-form.component.html',
    styleUrls: ['./entity-form.component.less'],
    standalone: false
})
export class EntityFormComponent implements OnInit, AfterViewInit, AfterViewChecked {

  constructor(private formBuilder:FormBuilder,private service:DataService,
              private utilityService:UtilityService,private logger:NGXLogger,
              private changerDetectorRef:ChangeDetectorRef,private router:Router,
              private activatedRoute:ActivatedRoute,private dailog:MatDialog,
              private entityService:ExternalEntityService,private permissionService:PermissionService,
              private toastrService:ToastrService) { }

  
   @Input() selectedDialCode: string | null = null; 
   @Output() dialCodeSelected = new EventEmitter<string>();            

  entityForm:FormGroup;
  readonly separatorKeysCodes = [ENTER, COMMA, SEMICOLON] as const;
  companyTypes:any;
  domicileTypes:any;
  entityDetailsList=[{name:'EXPORTER',label:'Exporter',isSelected:false,isHidden:false},
                    {name:'IMPORTER',label:'Importer',isSelected:false,isHidden:false},
                    {name:'OVERSEAAGENT',label:'Oversea Agent',isSelected:false,isHidden:false},
                    {name:'IATA',label:'IATA Agent',isSelected:false,isHidden:false},
                    {name:'FORWARDER',label:'Forwarder',isSelected:false,isHidden:false},
                    {name:'CONSOLIDATOR',label:'Consolidator/Coloader',isSelected:false,isHidden:false},
                    {name:'CUSTOMSBROKER',label:'Customs Broker',isSelected:false,isHidden:false},
                    {name:'TRANSPORTERLSP',label:'Transporter-LSP',isSelected:false,isHidden:false},
                    {name:'LINE',label:'Line / NVOCC',isSelected:false,isHidden:false},
                    {name:'SHIPPINGLINEAGENT',label:'Shipping Line Agent',isSelected:false,isHidden:false},
                    {name:'TRANSPORTERGTA',label:'Transporter-GTA',isSelected:false,isHidden:false},
                    {name:'CFS_WAREHOUSE',label:'CFS / Warehouse',isSelected:false,isHidden:false},
                    {name:'SURVEYOR',label:'Surveyor',isSelected:false,isHidden:false},
                    {name:'TRAINOPERATOR',label:'Train Operator',isSelected:false,isHidden:false},
                    {name:'CFS',label:'CFS',isSelected:false,isHidden:false}]

  private readonly domesticOnlyTypes = ['CUSTOMSBROKER','IATA','SURVEYOR','TRAINOPERATOR','TRANSPORTERGTA','TRANSPORTERLSP','CFS','OVERSEAAGENT','CFS_WAREHOUSE'];
  private readonly directOnlyTypes = ['EXPORTER','IMPORTER','SHIPPINGLINEAGENT'];

  // Maps raw EntityType enum name → display label for audit log values.
  private readonly ENTITY_TYPE_LABELS: { [key: string]: string } =
    this.entityDetailsList.reduce((acc, e) => { acc[e.name] = e.label; return acc; }, {} as { [key: string]: string });

  gstTypes:any;
  currencyList:any;
  entityGroupId:number=null;
  formData=new FormData();
  tdsDocument:any;
  entityId:number;
  entityGroupList:any;
  filteredGroup:ReplaySubject<IEntityGroup[]> = new ReplaySubject<IEntityGroup[]>(1);
  isExistingGroup = false;
  logoFile: File = null;
  logoFileName: string = '';
  logoDocument: any;
  onDestroy=new Subject<void>();
  entityLevelList:any;
  activeURL:any;
  responseId:number;
  tdsExemptionList = [
    { key: 'NONE',    label: 'No'      },
    { key: 'TOTAL',   label: 'Yes'     },
    { key: 'PARTIAL', label: 'Partial' }
  ];
  idToKYC:number;
  message:string;
  showDeactivateToggle: boolean = false;
  showReactivateToggle: boolean = false;
  checked:boolean=false;
  disableSubmit: boolean = false;
  isViewMode: boolean = false;
  entityCriteriaList = [
    { key: 'DIRECT',   label: 'Direct Cust / Vendor'   },
    { key: 'INDIRECT', label: 'Indirect Cust / Vendor' }
  ];
  countryIdToKYC:number;
  isEditedData:boolean=false;
  branchList: Array<{id?: number, _uid: number}> = [{ _uid: 0 }];
  activeBranchIndex: number = 0;
  visitedBranchIndexes = new Set<number>();
  private _nextBranchUid = 1;
  entityBranch1Address: any = null;
  branchSummaryList: any[] = [];
  isBranchPanelExpanded: boolean = false;
  branchDetailsMap: Map<number, any> = new Map();
  entityCreditDefaults: any = null;
  salesPersonList:any;
  customerList:any;
  addressConfig=new AddressConfig(true,true,true,false,true,false,false,true);
  documentCriteria:IDocumentCriteria={};
  @ViewChild('entityTabGroup') tabGroup: MatTabGroup;
  @ViewChild(AddressComponent) addressComponent;
  @ViewChild(KycDetailsComponent) kycDetailsComponent:KycDetailsComponent;
  @ViewChild(CreditTermsComponent) creditComponent;
  @ViewChildren(EntityBranchFormComponent) branchFormComponents: QueryList<EntityBranchFormComponent>;
  searching:boolean=false;
  reactivatePermission:boolean=false;
  deactivatePermission:boolean=false;
  editPermission:boolean=false;
  addPermission:boolean=false;
  auditLogTabs: AuditLogTab[] = [];
  typeSearchCtrl = this.formBuilder.control('');
  customerSearchCtrl = this.formBuilder.control('');
  salesPersonSearchCtrl = this.formBuilder.control('');
  companySearchCtrl = this.formBuilder.control('');
  filtered:ReplaySubject<ICurrency[]> = new ReplaySubject<ICurrency[]>(1);
  filteredCustomer:ReplaySubject<IEmployee[]> = new ReplaySubject<IEmployee[]>(1);
  filteredSalesPerson:ReplaySubject<IEmployee[]> = new ReplaySubject<IEmployee[]>(1);
  filteredCompanyType:ReplaySubject<IEnum[]> = new ReplaySubject<IEnum[]>(1);
  fileName: any;
  iconTextCell: string = "Select country code and then enter number. Press Enter to add. Special characters will be removed. Max 15 characters per number."
  iconText: string = "Identifies whether this Entity’s relationship with the company is directly related to shipping, forwarding, logistics or is a general ledger entity type";
  filteredSalesCordinator:ReplaySubject<IEmployee[]> = new ReplaySubject<IEmployee[]>(1);
  filteredSalesSupport:ReplaySubject<IEmployee[]> = new ReplaySubject<IEmployee[]>(1);
  filteredTracker:ReplaySubject<IEmployee[]> = new ReplaySubject<IEmployee[]>(1); 
  salesCoOrdinatorSearchCtrl= this.formBuilder.control('');
  salesCoOrdinatorList:any;
  salesSupportSearchCtrl= this.formBuilder.control('');
  salesSupportList:any;
  trackerSearchCtrl= this.formBuilder.control('');
  trackerList:any;
  cellPattern = /^(\+\d{1,3}[- ]?)?\d{1,15}$/;
  showPatternError:boolean=false;
  showLengthError:boolean=false;
  hasChips: boolean = false;
  allDialCodes: { dialCode: string; countryName: string }[] = [];
  dialCodeSearchText: string = '';
  dialCodeSearchCtrl = new FormControl();
  filteredDialCodes$ = new ReplaySubject<{dialCode: string, countryName: string}[]>(1); 

  emailPattern = "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$";
  duplicateEmailError: string | null = null;

  ngOnInit(): void {
    this.getAllPermissions();
    this.initializeForm();
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['location'] === 'view') {
        this.isViewMode = true;
        this.disableSubmit = true;
      }
    });
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        this.entityId=+param['id'];
        if(!isNaN(this.entityId)){
          this.idToKYC=this.entityId;
          this.getEntityById();
        } else {
          this.resetMultiValueFields();
        }
      }
    )
    this.activeURL=location.href;
    this.filterSalesPerson();
    this.filterCustomer();
    this.filterCompanyTypes();
    this.filterEntityGroups();
    this.getFilter();
    this.getCompanyTypes();
    this.getDomicileTypes();
    this.setCountryValueChangeEvent();
    this.getGstTypes();
    this.getCurrenyList();
    this.getEntityGroupList();
    this.setGroupNameChangeEvent();
    this.getEntityLevelList();
    this.setCountryValueChangeEvent();
    this.setDomicileValueChangeEvent();
    this.setEntityCriteriaValueChangeEvent();
    this.setTdsExemptionValueChangeEvent();
    this.setEntityGSTTypeValueChangeEvent();
    this.setEntityCriteriaValueChangeEvent();
    this.getSalesList();
    this.getCustomerList();
    this.getSalesCordinatorList();
    this.getTrackerList();
    this.filterSalesCoOrdinator();
    this.filterSalesSupport();
    this.filtertracker();
    this.setupDialCodeSearch();
    this.auditLogTabs = [
      { label: 'Entity Details',              icon: 'business',        processData: this.processEntityRecords },
      { label: 'Tax and Credit Details',      icon: 'account_balance', processData: this.processTaxCreditRecords },
      { label: 'Group Details',               icon: 'groups',          processData: this.processEntityGroupRecords,           propertyPattern: 'EXTERNAL_ENTITY.groups.' },
      { label: 'KYC Details',                 icon: 'verified_user',   processData: this.processEntityKycRecords },
    ];
  }


  initializeForm(){
    this.entityForm=this.formBuilder.group({
      id:[],
      code:[null,[Validators.maxLength(6)]],
      name:['',[Validators.required,Validators.maxLength(60)]],
      legalName:[null,[Validators.maxLength(60)]],
      keyPersonName:[null,[Validators.maxLength(40), Validators.pattern('^[a-zA-Z ]*$')]],
      externalEntityAlias:this.formBuilder.array([]),
      isLegalNameSameAsName:[],
      email:this.formBuilder.array([],[Validators.maxLength(100)]),
      cellNumberDetails: this.formBuilder.array([], [this.validateCellNumberDetails()]),
      landlineNo:[null,[Validators.pattern('^\\+?[0-9 ]{1,20}$')]],
      companyType:[null,[Validators.required]],
      salesPersonId:[null],
      customerSupportId:[null],
      domicile:[null,[Validators.required]],
      gstType:[null],
      gstNo:[null,[]],
      panNoTaxId:['',[Validators.required,Validators.maxLength(16),Validators.pattern('^[A-Z0-9]+$')]],
      entityDetails:this.formBuilder.array([]),
      currencyId:[null],
      groups:this.getEntityGroupForm(),
      newGroupDetail:this.getEntityGroupForm(),
      customerFlag:this.entityService.getCreditDetailForm().get('customerFlag'),
      customerEntityLevel:this.entityService.getCreditDetailForm().get('customerEntityLevel'),
      customerCreditDays:this.entityService.getCreditDetailForm().get('customerCreditDays'),
      customerCreditAmount:this.entityService.getCreditDetailForm().get('customerCreditAmount'),
      vendorFlag:this.entityService.getCreditDetailForm().get('vendorFlag'),
      vendorEntityLevel:this.entityService.getCreditDetailForm().get('vendorEntityLevel'),
      vendorCreditDays:this.entityService.getCreditDetailForm().get('vendorCreditDays'),
      vendorCreditAmount:this.entityService.getCreditDetailForm().get('vendorCreditAmount'),
      customerApprovalStatus:this.entityService.getCreditDetailForm().get('customerApprovalStatus'),//
      vendorApprovalStatus:this.entityService.getCreditDetailForm().get('vendorApprovalStatus'),//
      tdsExemption:['NONE',[Validators.required]],
      tdsExemptionWefDate:[],
      tdsExemptionValidUptoDate:[],
      tdsExemptionPercentage:[],
      entityCriteria:[null],
      customerCategory:[null],
      vendorCategory:[null],
      customerCurrencyId:[null],
      vendorCurrencyId:[null],
      address:this.utilityService.getAddressForm(),
      activeFlag:[null],
      currencyName:[null],
      status:[],
      submittedForApproval:[],
      customerCreditTermId:[],
      vendorCreditTermId:[],
      entityDocuments:[],
      branchDetailsDto:[],
      entityChecked:[],
      salesCoOrdinatorId:[null],
      salesSupportId:[null],
      TrackerId:[null],
      chargeMechanismType:[null],
      displayNameForMobileApp:[null,[Validators.maxLength(100)]]
    },
      {
        validator: this.checkEquals('name', 'legalName')
      }
    )
  }

  private resetMultiValueFields(){
    this.getEmails().clear();
    while (this.cellNumberDetails.length !== 0) { this.cellNumberDetails.removeAt(0); }
    this.externalEntityAlias.clear();
    this.entityDetails.clear();
    this.entityDetailsList?.forEach(e => e.isSelected = false);
  }

  getEntityGroupForm(data?:any){
    return this.formBuilder.group({
      id:[data?data.id:null],
      name:[data?data.name:null],
      code:[data?data.code:null],
      displayName:[data?data.displayName:null]
    })
  }

  getEntityAlias(){
    return this.externalEntityAlias.value;
  }

  removeEntityAlias(index:number){
    this.externalEntityAlias.removeAt(index);
    this.entityForm.markAsDirty();
  }

  addEntityAlias(event:MatChipInputEvent)
  {
    const value=(event.value || '').trim();
    if(value.length>0 && !_.findWhere(this.externalEntityAlias.value,{name:value})){
     this.externalEntityAlias.push(this.utilityService.getAliasForm(null,value));
     this.entityForm.markAsDirty();
    }
    if (event.input) {
      event.input.value = '';
    }
  }

  onSave(){
    this.status.setValue('APPROVED');
    this.save();
  }

  hasUnsavedChanges(): boolean {
    if (this.entityForm?.dirty) { return true; }
    if (this.addressComponent?.address?.dirty) { return true; }
    if (this.creditComponent?.creditTermForm?.dirty) { return true; }
    if ((this.kycDetailsComponent?.documents?.length ?? 0) > 0) { return true; }
    if (this.logoFile != null) { return true; }
    return (this.branchFormComponents?.toArray() || []).some(b => b.hasUnsavedChanges());
  }

  save(){
    const isValid = this.addressComponent.address.valid;
     this.logger.info('External Entity Form Value',this.entityForm.value);
     this.setValue();
     this.entityForm.markAllAsTouched();
     this.addressComponent.address.markAllAsTouched();
     this.creditComponent.creditTermForm.markAllAsTouched();
     const branchCreditValid = this.validateBranchCreditAmounts();
     if (!branchCreditValid) {
       this.utilityService.notifier(Message.BRANCH_CREDIT_VALIDATION_ERROR, 'error');
     }
     const branchFormsValid = this.validateAllBranchForms();
     if( this.kycDetailsComponent.areAllMandatoryDocAdded() && this.entityForm.valid && isValid && this.creditComponent.creditTermForm.valid && branchCreditValid && branchFormsValid)
     {
       if (this.entityDetails.length === 0) {
         this.utilityService.toastrInfoMessage(Message.ENTITY_TYPE_REQUIRED);
         return;
       }
       if (!this.chargeMechanismType.value) {
         this.utilityService.toastrInfoMessage(Message.CHARGE_MECHANISM_REQUIRED);
         return;
       }
       this.isEditedData=true;
        if(this.entityId){
          this.openDailog('Edited Data will be saved Do you wish to continue?');
        }
        else {
          this.openDailog('Data will be saved Do you wish to continue?');
        }
     } else {
       const firstInvalidTab = this.getFirstInvalidTabIndex();
       if (firstInvalidTab >= 0 && this.tabGroup) {
         this.tabGroup.selectedIndex = firstInvalidTab;
       }
     }
  }

  private getFirstInvalidTabIndex(): number {
    // Tab 0: Entity Details — name, companyType, address
    const tab0Controls = ['name', 'companyType'];
    if (tab0Controls.some(c => this.entityForm.get(c)?.invalid)) return 0;
    if (this.addressComponent?.address?.invalid) return 0;

    // Tab 1: Tax & Credit Details — domicile, panNoTaxId, tdsExemption, gstType, gstNo + credit form
    const tab1Controls = ['domicile', 'panNoTaxId', 'tdsExemption', 'gstType', 'gstNo'];
    if (tab1Controls.some(c => this.entityForm.get(c)?.invalid)) return 1;
    if (this.creditComponent?.creditTermForm?.invalid) return 1;

    // Tab 2: Group Details — no required fields

    // Tab 3: KYC Details — mandatory docs
    if (!this.kycDetailsComponent?.areAllMandatoryDocAdded()) return 3;

    return -1;
  }

  private validateAllBranchForms(): boolean {
    if (!this.branchFormComponents || this.branchFormComponents.length === 0) return true;
    let allValid = true;
    this.branchFormComponents.forEach(branchForm => {
      if (branchForm.hasUnsavedChanges()) {
        if (!branchForm.validateBranch()) {
          allValid = false;
        }
      }
    });
    return allValid;
  }

  validateBranchCreditAmounts(): boolean {
    if (!this.branchFormComponents || !this.branchFormComponents.length) return true;

    const creditForm = this.creditComponent.creditTermForm;
    const customerAmt = parseFloat(creditForm.get('customerCreditAmount').value) || 0;
    const vendorAmt = parseFloat(creditForm.get('vendorCreditAmount').value) || 0;
    if (customerAmt <= 0 && vendorAmt <= 0) return true;

    const branches = this.branchFormComponents.toArray();
    const totals = branches.reduce(
      (acc, b) => {
        const sums = b.getCreditDetailsSumByType();
        return { customer: acc.customer + sums.customer, vendor: acc.vendor + sums.vendor };
      },
      { customer: 0, vendor: 0 }
    );

    let valid = true;
    const customerCtrl = creditForm.get('customerCreditAmount');
    const vendorCtrl = creditForm.get('vendorCreditAmount');

    if (customerAmt > 0 && totals.customer > customerAmt) {
      customerCtrl.setErrors({ ...(customerCtrl.errors || {}), belowBranchSum: true });
      valid = false;
    } else {
      if (customerCtrl.hasError('belowBranchSum')) {
        const errors = { ...(customerCtrl.errors || {}) };
        delete errors['belowBranchSum'];
        customerCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }

    if (vendorAmt > 0 && totals.vendor > vendorAmt) {
      vendorCtrl.setErrors({ ...(vendorCtrl.errors || {}), belowBranchSum: true });
      valid = false;
    } else {
      if (vendorCtrl.hasError('belowBranchSum')) {
        const errors = { ...(vendorCtrl.errors || {}) };
        delete errors['belowBranchSum'];
        vendorCtrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    }
    return valid;
  }

  saveEntity() {
    let method = (this.entityId) ? 'put' : 'post';
    let message = (this.entityId) ? 'updated' : 'saved';
    const formData = { ...this.entityForm.value };
    if (formData.currencyId) {
      formData.currency = { id: formData.currencyId, name: formData.currencyName };
    }
    delete formData.currencyId;
    delete formData.currencyName;
    formData.cellNumberDetails = formData.cellNumberDetails.map(item => {
      const cleanedNumber = item.number.replace(/[^\d]/g, '');

      if (cleanedNumber.length > 15) {
        throw new Error(`Phone number can not exceed more than 15 digits: ${item.dialCode} ${item.number}`);
      }

      return {
        dialCode: item.dialCode,
        number: cleanedNumber
      };
    });
    const successMessage = this.entityId ? Message.ENTITY_UPDATED : Message.ENTITY_SAVED;
    this.service[method](Api.EXTERNAL_ENTITY, formData).subscribe(entityIdValue => {
      this.formData.set('referenceId', entityIdValue.id);
      this.responseId = entityIdValue.id;
      this.entityId = entityIdValue.id;
      this.idToKYC = this.responseId;
      this.saveFile();
      this.saveLogo(entityIdValue.id);
      this.saveKycDocs(this.idToKYC);
      this.saveEmbeddedBranches(entityIdValue.id, successMessage);
    });
  }

  private saveEmbeddedBranches(entityId: number, successMessage?: string, isDraft = false): void {
    const customerFlag = this.entityForm.get('customerFlag')?.value ?? false;
    const vendorFlag = this.entityForm.get('vendorFlag')?.value ?? false;
    const customerCreditDays = this.entityForm.get('customerCreditDays')?.value ?? null;
    const customerCreditAmount = this.entityForm.get('customerCreditAmount')?.value ?? null;
    const vendorCreditDays = this.entityForm.get('vendorCreditDays')?.value ?? null;
    const vendorCreditAmount = this.entityForm.get('vendorCreditAmount')?.value ?? null;

    const allBranches = this.branchFormComponents ? this.branchFormComponents.toArray() : [];
    const dirtyBranches = allBranches.filter(b => b.hasUnsavedChanges());

    if (dirtyBranches.length === 0) {
      if (successMessage) { this.utilityService.notifier(successMessage, 'success'); }
      this.router.navigate([APP_ROUTES.ENTITY_LIST]);
      return;
    }

    const allValid = isDraft
      ? dirtyBranches.every(b => b.validateBranchForDraft())
      : dirtyBranches.every(b => b.validateBranch());
    if (!allValid) {
      return;
    }

    dirtyBranches.forEach(branchForm => {
      branchForm.entityBranchForm.patchValue({
        customerFlag, vendorFlag,
        customerCreditDays, customerCreditAmount,
        vendorCreditDays, vendorCreditAmount
      });
    });

    // Save branches sequentially; navigate only after ALL complete
    from(dirtyBranches).pipe(
      concatMap(branchForm => branchForm.saveForEntityAsync(entityId, isDraft))
    ).subscribe({
      error: err => {
        this.logger.error('Branch save error', err);
        this.router.navigate([APP_ROUTES.ENTITY_LIST]);
      },
      complete: () => {
        if (successMessage) { this.utilityService.notifier(successMessage, 'success'); }
        this.router.navigate([APP_ROUTES.ENTITY_LIST]);
      }
    });
  }

  setValue(){
    this.address=this.addressComponent.address.value;
    this.entityDetails.clear();
    this.entityDetailsList?.forEach(element => {
      if(element?.isSelected){
        this.entityDetails.push(this.formBuilder.control(element.name));
      }
    });
    this.customerFlag=this.creditComponent.creditTermForm.get('customerFlag').value;
    this.customerEntityLevel=this.creditComponent.creditTermForm.get('customerEntityLevel').value;
    this.customerCreditDays=this.creditComponent.creditTermForm.get('customerCreditDays').value,
    this.customerCreditAmount=this.creditComponent.creditTermForm.get('customerCreditAmount').value,
    this.vendorFlag=this.creditComponent.creditTermForm.get('vendorFlag').value,
    this.vendorEntityLevel=this.creditComponent.creditTermForm.get('vendorEntityLevel').value,
    this.vendorCreditDays=this.creditComponent.creditTermForm.get('vendorCreditDays').value,
    this.vendorCreditAmount=this.creditComponent.creditTermForm.get('vendorCreditAmount').value,
    this.customerApprovalStatus=this.creditComponent.creditTermForm.get('customerApprovalStatus').value,//
    this.vendorApprovalStatus=this.creditComponent.creditTermForm.get('vendorApprovalStatus').value,//
    this.customerCategory=this.creditComponent.creditTermForm.get('customerCategory')?.value ?? null,
    this.vendorCategory=this.creditComponent.creditTermForm.get('vendorCategory')?.value ?? null,
    this.customerCurrencyId=this.creditComponent.creditTermForm.get('customerCurrencyId')?.value ?? null,
    this.vendorCurrencyId=this.creditComponent.creditTermForm.get('vendorCurrencyId')?.value ?? null
  }

  trimControl(ctrl: AbstractControl) {
    if (ctrl?.value != null) {
      ctrl.setValue(ctrl.value.trim(), { emitEvent: false });
      ctrl.updateValueAndValidity();
    }
  }

  cancel(){
    if(this.hasUnsavedChanges())
    {
      this.isEditedData = false;
      this.id.value?this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT):this.openDailog(Message.CANCEL_OPEN_DAILOG);
    }
    else {
      this.router.navigate([APP_ROUTES.ENTITY_LIST]);
    }
  }

  saveAsDraft(){
    this.entityForm.markAsUntouched();
    this.addressComponent?.address?.markAsUntouched();
    this.creditComponent?.creditTermForm?.markAsUntouched();
    this.name.markAsTouched();
    if(this.name.value?.trim()){
      this.setValue();
      const formData = { ...this.entityForm.value };
      if (formData.currencyId) {
        formData.currency = { id: formData.currencyId, name: formData.currencyName };
      }
      delete formData.currencyId;
      delete formData.currencyName;
      const method = this.entityId ? 'put' : 'post';
      const draftSuccessMessage = this.entityId ? Message.ENTITY_DRAFT_UPDATED : Message.ENTITY_DRAFT_SAVED;
      this.service[method](Api.EXTERNAL_ENTITY_SAVE_AS_DRAFT, formData).subscribe(entityIdValue => {
        this.formData.set('referenceId', entityIdValue.id);
        this.responseId = entityIdValue.id;
        this.entityId = entityIdValue.id;
        this.idToKYC = this.responseId;
        this.saveFile();
        this.saveLogo(entityIdValue.id);
        this.saveKycDocs(this.idToKYC);
        this.saveEmbeddedBranches(entityIdValue.id, draftSuccessMessage, true);
      });
    } else {
      this.utilityService.toastrErrorMessage(Message.ENTITY_NAME_REQUIRED_DRAFT);
    }
  }

  onDomicileChange(label:string){
    this.logger.info('Label value',label);
  }

  setEntityCriteriaValueChangeEvent(){
  }

  setGroupNameChangeEvent(){
    this.groupName.valueChanges.subscribe(value => {
      this.logger.info('Group Name',value);
      let group = value ? _.findWhere(this.entityGroupList, { name: value }) : null;
      if(group){
        this.groupCode.setValue(group.code);
        this.groupId.setValue(group.id);
        this.entityGroupId = group.id;
        this.isExistingGroup = true;
      } else if (!value || !this.groupId.value) {
        // null value (user cleared / selected "None") OR no group was linked yet → clear all
        this.groupCode.setValue(null);
        this.groupId.setValue(null);
        this.entityGroupId = null;
        this.isExistingGroup = false;
      }
      // else: non-null name not in list but a group IS already linked → user is renaming;
      // keep groupId/groupCode so the backend updates the existing group record.
    })
  }

  openDeactivateForm(e:MatSlideToggleChange)
  {
    if(this.deactivatePermission){
      let data={id:this.entityId,route:APP_ROUTES.ENTITY_LIST,message:'Entity',api:Api.EXTERNAL_ENTITY_DEACTIVATE}
      const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
      dailogRef.afterClosed().subscribe(result => {
        if (result !== true) { this.checked = false; }
      });
    } else {
      this.checked = false;
      this.utilityService.notifier(Message.DEACTIVATE_PERMISSION_WARNING,"warning");
    }
  }

  openReactivateForm(e:MatSlideToggleChange)
  {
    if(this.reactivatePermission){
      let data={id:this.entityId,route:APP_ROUTES.ENTITY_LIST,message:'Entity',api:Api.EXTERNAL_ENTITY_REACTIVATE}
      const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
      dailogRef.afterClosed().subscribe(result => {
        if (result !== true) { this.checked = false; }
      });
    } else {
      this.checked = false;
      this.utilityService.notifier(Message.ACTIVATE_PERMISSION_WARNING,"warning");
    }
  }

  onEntityDetailChanged(name:string,event:any){
    this.entityForm.markAsDirty();
    let detail=_.findWhere(this.entityDetailsList, { name: name});
    if(event.checked){
      detail.isSelected=true;
    } else {
      detail.isSelected=false;
    }
  }

  filterEntityGroups() {
    this.groupName.valueChanges.pipe(
        startWith(''),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!search) return this.entityGroupList || [];
          const s = search.toLowerCase();
          return this.entityGroupList?.filter(group =>
            group?.name?.toLowerCase().indexOf(s) > -1
            || group?.code?.toLowerCase().indexOf(s) > -1);
        })
      )
      .subscribe(filteredGroup => {
        this.filteredGroup.next(filteredGroup);
      });
  }

  onLogoSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || !input.files[0]) return;
    const file = input.files[0];
    const allowed = ['image/png', 'image/jpeg', 'image/svg+xml'];
    if (!allowed.includes(file.type)) {
      alert('Only PNG, JPG and SVG files are allowed.');
      input.value = '';
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      alert('Logo file size must not exceed 2 MB.');
      input.value = '';
      return;
    }
    this.logoFile = file;
    this.logoFileName = file.name;
  }

  onViewCompanies()
  {
    const dailogRef=this.dailog.open(ViewLinkedCompaniesComponent,{
      data:this.entityGroupId,
      width:'480px',
      maxHeight:'80vh',
      autoFocus:false,
      panelClass:'linked-companies-dialog-panel'
    });
  }
 
  addBranch() {
    this.branchList.push({ _uid: this._nextBranchUid++ });
    this.activeBranchIndex = this.branchList.length - 1;
    this.visitedBranchIndexes.add(this.activeBranchIndex);
    this.entityForm.markAsDirty();
  }

  removeBranch(index: number) {
    if (this.branchList.length <= 1 || index < 1) { return; }
    if (this.branchList[index]?.id) { return; } // already saved — can't remove here
    this.branchList.splice(index, 1);
    if (this.activeBranchIndex >= this.branchList.length) {
      this.activeBranchIndex = this.branchList.length - 1;
    } else if (this.activeBranchIndex > index) {
      this.activeBranchIndex--;
    }
    // Rebuild visitedBranchIndexes with shifted indices
    const newVisited = new Set<number>();
    this.visitedBranchIndexes.forEach(idx => {
      if (idx < index) newVisited.add(idx);
      else if (idx > index) newVisited.add(idx - 1);
    });
    this.visitedBranchIndexes = newVisited;
    this.entityForm.markAsDirty();
  }

  onBranchTabSelected(index: number): void {
    this.visitedBranchIndexes.add(index);
  }

  onBranchSaved(event: { id: number }, index: number) {
    Object.assign(this.branchList[index], { id: event.id });
    this.reloadBranchData();
  }

  onHeadquarterSelected(currentIndex: number): void {
    const components = this.branchFormComponents.toArray();
    const otherHQ = components.find((c, i) => i !== currentIndex && c.branchType?.value === 'HEADQUARTER');
    if (otherHQ) {
      this.utilityService.notifier(
        Message.HEADQUARTER_BRANCH_DUPLICATE,
        'warning'
      );
      components[currentIndex].entityBranchForm.get('branchType').setValue(null);
    }
  }

  private reloadBranchData() {
    if (this.entityId) {
      this.service.get(Api.ENTITY_BRANCH_LIST, { entiyId: this.entityId }).subscribe((res: any[]) => {
        this.entityForm.get('branchDetailsDto').setValue(res || []);
        this.branchSummaryList = res || [];
      });
    }
  }

  loadBranchTabs() {
    if (this.entityId) {
      this.service.get(Api.ENTITY_BRANCH_LIST, { entiyId: this.entityId }).subscribe((res: any[]) => {
        if (res && res.length > 0) {
          this.branchList = res.map((b, i) => ({ id: b.id, _uid: i }));
          this._nextBranchUid = res.length;
          this.branchSummaryList = res;
          this.isBranchPanelExpanded = true;
        } else {
          this.branchList = [{ _uid: 0 }];
          this._nextBranchUid = 1;
          this.branchSummaryList = [];
        }
        this.entityForm.get('branchDetailsDto').setValue(res || []);
      });
    }
  }

  toggleBranchPanel() {
    this.isBranchPanelExpanded = !this.isBranchPanelExpanded;
  }

  selectBranch(index: number) {
    this.activeBranchIndex = index;
  }

  getBranchAddress(branch: any): string {
    const addr = branch.address;
    if (!addr) return branch.branchAddress || '';
    const parts: string[] = [];
    if (addr.location) parts.push(addr.location);
    if (addr.cityName) parts.push(addr.cityName);
    const base = parts.join(', ');
    return addr.pincode ? `${base} - ${addr.pincode}` : base;
  }

  trackBranch(_: number, branch: { id?: number; _uid: number }) {
    return branch._uid;
  }

  filesSelected(files){
    if(this.submittedForApproval.value){ return; }
    if (!files || files.length === 0) return;
    const file = files[0];
    const allowed = ['application/pdf','image/jpeg','image/png'];
    if (!allowed.includes(file.type)) {
      this.toastrService.error('Only PDF, JPG and PNG files are allowed.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      this.toastrService.error('File size must not exceed 5 MB.');
      return;
    }
    this.formData.set('file', file);
    this.formData.set('referenceName','External Entity');
    this.formData.set('code','10');
    this.formData.set('type','TDS');
    this.formData.set('name', file.name);
    this.fileName = file.name;
    this.entityForm.markAsDirty();
  }

  saveFile(){
    this.logger.info('This is for sez form')
    if(this.formData.get('name')!=null){
        if(this.tdsDocument){
          this.formData.set('id',this.tdsDocument.id);
        }
        this.utilityService.upload(this.formData)
        .subscribe(response=>{
          this.logger.info('file uploaded successfully');
        })
    }
  }

  private saveLogo(entityId: number) {
    if (!this.logoFile) return;
    const logoFormData = new FormData();
    logoFormData.set('file', this.logoFile);
    logoFormData.set('code', '32');
    logoFormData.set('name', 'Entity Company Logo');
    logoFormData.set('referenceName', 'External Entity');
    logoFormData.set('referenceId', String(entityId));
    logoFormData.set('type', 'Entity_Logo');
    this.utilityService.upload(logoFormData).subscribe(response => {
      this.logger.info('Logo uploaded successfully');
      this.logoFile = null;
    });
  }

  downloadFile() {
    // Freshly added file (not yet saved) — download directly from the local File
    const localFile = this.formData.get('file');
    if (localFile instanceof File) {
      this.triggerDocDownload(localFile, localFile.name);
      return;
    }
    if (this.tdsDocument) {
      this.service.donwload(this.tdsDocument.fileName).subscribe((data: Blob) => {
        if (data) {
          this.triggerDocDownload(data, this.tdsDocument.originalFileName || 'document');
        }
      });
    }
  }

  previewTdsFile() {
    // Freshly added file (not yet saved) — preview from the local File
    const localFile = this.formData.get('file');
    if (localFile instanceof File) {
      this.openDocPreview(localFile, localFile.name, localFile.type);
      return;
    }
    if (this.tdsDocument) {
      this.service.donwload(this.tdsDocument.fileName).subscribe((data: Blob) => {
        if (data) {
          this.openDocPreview(data, this.tdsDocument.originalFileName,
            this.getDocMimeType(this.tdsDocument.originalFileName));
        }
      });
    }
  }

  private openDocPreview(blob: Blob, fileName: string, contentType: string) {
    const mime = contentType || this.getDocMimeType(fileName);
    const isImage = mime.startsWith('image/');
    const typedBlob = new Blob([blob], { type: mime });
    const url = window.URL.createObjectURL(typedBlob);
    const ref = this.dailog.open(DocumentPreviewDialogComponent, {
      data: { url, fileName, isImage }, maxWidth: '95vw', maxHeight: '95vh'
    });
    ref.afterClosed().subscribe(() => window.URL.revokeObjectURL(url));
  }

  private triggerDocDownload(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName || 'document';
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  private getDocMimeType(fileName: string): string {
    const ext = (fileName || '').split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'png':  return 'image/png';
      case 'jpg':
      case 'jpeg': return 'image/jpeg';
      case 'gif':  return 'image/gif';
      case 'bmp':  return 'image/bmp';
      case 'pdf':  return 'application/pdf';
      default:     return 'application/octet-stream';
    }
  }

  checkEquals(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const nameControl = formGroup.controls[controlName];
      const legalNameControl = formGroup.controls[matchingControlName];
      let name = nameControl.value;
      let legalName = legalNameControl.value;
      if (name != "") {
        if (name?.toLowerCase() === legalName?.toLowerCase()) {
          legalNameControl.setErrors({ checkEqual: true });
        } else {
          legalNameControl.setErrors(null);
        }
      }
    }
  }
  

  setCountryValueChangeEvent(){
    this.countryId?.valueChanges.subscribe(countryId => {
      this.countryIdToKYC=countryId;
    })
  }

  saveKycDocs(id: number): void {
    this.kycDetailsComponent.uploadDocuments(id).subscribe({
      next: (result) => {
        if (result !== null) {
          this.service.put(Api.ENTITY_CAPTURE_DOCUMENT_AUDIT_SNAPSHOT(id), {}).subscribe();
        }
      }
    });
  }

  setDomicileValueChangeEvent(){
     this.domicile.valueChanges.subscribe(domicileValue => {
      this.entityDetails.clear();
        if(domicileValue==='DOMESTIC'){
          this.gstType.setValidators([Validators.required]);
          this.panNoTaxId.setValidators([Validators.required, Validators.maxLength(16),
            Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')]);
        } else {
          this.gstType.clearValidators();
          this.gstType.reset();
          this.gstNo.reset();
          this.panNoTaxId.setValidators([Validators.required, Validators.maxLength(16),
            Validators.pattern('^[A-Z0-9]+$')]);
        }
        this.panNoTaxId.updateValueAndValidity();
        this.onDomicileChange(domicileValue);
     });
  }

  setEntityGSTTypeValueChangeEvent(){
    this.gstType.valueChanges.subscribe(gstTypeValue => {
      if(gstTypeValue==='REGISTERED'){
         this.gstNo.setValidators([Validators.required,
           Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')])
      } else {
        this.gstNo.clearValidators();
        this.gstNo.reset();
      }
      this.gstNo.updateValueAndValidity();
    })
  }

  setTdsExemptionValueChangeEvent(){
    this.tdsExemption.valueChanges.subscribe(tdsValue => {
      if(tdsValue==='PARTIAL'){
        this.tdsExemptionWefDate.setValidators([Validators.required]);
        this.tdsExemptionValidUptoDate.setValidators([Validators.required]);
        // 0.01 – 99.99: strictly between 0 and 100, up to 2 decimal places
        this.tdsExemptionPercentage.setValidators([Validators.required,
          Validators.pattern('^(?:[1-9][0-9]?(?:\\.[0-9]{1,2})?|0\\.(?:0[1-9]|[1-9][0-9]?))$')]);
      } else if(tdsValue==='TOTAL') {
        this.tdsExemptionWefDate.setValidators([Validators.required]);
        this.tdsExemptionValidUptoDate.setValidators([Validators.required]);
        this.tdsExemptionPercentage.clearValidators();
      } else {
        this.tdsExemptionWefDate.clearValidators();
        this.tdsExemptionValidUptoDate.clearValidators();
        this.tdsExemptionPercentage.clearValidators();
      }
      this.tdsExemptionWefDate.updateValueAndValidity();
      this.tdsExemptionValidUptoDate.updateValueAndValidity();
      this.tdsExemptionPercentage.updateValueAndValidity();
      this.resetTDSValues();
    })
  }

  getEntityById(){
    if(this.entityId){
      this.service.get(Api.EXTERNAL_ENTITY + '/' + this.entityId).subscribe((entity: any) => {
        this.logger.info("Entity By ID Response", entity);

        this.entityCreditDefaults = {
          customerFlag: entity.customerFlag ?? false,
          vendorFlag: entity.vendorFlag ?? false,
          customerCreditDays: entity.customerCreditDays ?? null,
          customerCreditAmount: entity.customerCreditAmount ?? null,
          vendorCreditDays: entity.vendorCreditDays ?? null,
          vendorCreditAmount: entity.vendorCreditAmount ?? null
        };

        try {
          this.getTdsDocument(entity);
          this.setValueToForm(entity);
        } catch(e) {
          this.logger.error('Error in setValueToForm', e);
        }
        this.message = this.getStatus(entity);
        this.disableForm(entity);

        // Branch details are embedded in the entity response — no extra API calls needed
        const branchDetails: any[] = entity.branchDetails || [];
        this.branchSummaryList = branchDetails;
        this.entityForm.get('branchDetailsDto').setValue(branchDetails);

        if (branchDetails.length === 0) {
          this.branchList = [{ _uid: 0 }];
          this._nextBranchUid = 1;
          return;
        }

        this.branchDetailsMap = new Map(branchDetails.map(b => [b.id as number, b]));
        this.branchList = branchDetails.map((b, i) => ({ id: b.id, _uid: i }));
        this._nextBranchUid = branchDetails.length;
        this.isBranchPanelExpanded = true;
      });
    }
  }

  setValueToForm(res){
    while (this.cellNumberDetails.length !== 0) {
  this.cellNumberDetails.removeAt(0);
}

 if (res.cellNumberDetails && Array.isArray(res.cellNumberDetails)) {
    res.cellNumberDetails.forEach((cellDetail: { dialCode: string; number: string }) => {
      const formattedNumber = this.formatPhoneNumberForDisplay(cellDetail.number);
      
      this.cellNumberDetails.push(this.formBuilder.group({
        dialCode: [cellDetail.dialCode, Validators.required],
        number: [formattedNumber, [Validators.required, this.validateSinglePhoneNumber()]]
      }));
    });
  }
    this.logger.info('Entity By Id Res',res);
    res.externalEntityAlias?.forEach(entityAlias => {
      this.externalEntityAlias.push(this.utilityService.getAliasForm(entityAlias.id,entityAlias.name));
    });
    // Reset all selections first so the checkboxes reflect exactly what's saved
    // (prevents stale isSelected flags from being re-saved as extra entity types).
    this.entityDetailsList?.forEach(e => e.isSelected = false);
    this.entityDetails.clear();
    res.entityDetails?.forEach(entityObj => {
        this.entityDetails.push(this.formBuilder.control(entityObj));
        let entity=_.findWhere(this.entityDetailsList,{name:entityObj});
        if(entity){  entity.isSelected=true;}
    });
    this.addressComponent?.address?.patchValue({...res.address, landMarkSet: res.address?.landMarkSet || []});
    // this.group.patchValue(res.groups);
    this.entityForm?.patchValue({...res,
      cellNumberDetails: [],
      email: [],
      externalEntityAlias: res.externalEntityAlias || [],
      entityDetails: res.entityDetails || [],
      groups:res.groups || {},
      newGroupDetail:res?.newGroupDetail || {},
      address: {...res.address, landMarkSet: res.address?.landMarkSet || []},
      currencyId: res.currency?.id ?? null,
      currencyName: res.currency?.name ?? null
    });
    // tdsExemption.valueChanges calls resetTDSValues() on every change including during patchValue,
    // which wipes WEF/Upto/Percentage. Re-set them explicitly after patchValue.
    if (res.tdsExemption === 'PARTIAL' || res.tdsExemption === 'TOTAL') {
      this.tdsExemptionWefDate.setValue(res.tdsExemptionWefDate ?? null, { emitEvent: false });
      this.tdsExemptionValidUptoDate.setValue(res.tdsExemptionValidUptoDate ?? null, { emitEvent: false });
      if (res.tdsExemption === 'PARTIAL') {
        this.tdsExemptionPercentage.setValue(res.tdsExemptionPercentage ?? null, { emitEvent: false });
      }
    }
    // Restore group form controls explicitly after patchValue. The groupName.valueChanges
    // subscription in setGroupNameChangeEvent() runs during patchValue and clears groupId/groupCode
    // whenever entityGroupList has not yet loaded (race condition). That causes the backend to treat
    // the existing group as a new one and insert a duplicate record, which then shows up alongside
    // the original in the Group Name dropdown.
    if (res.groups?.id) {
      this.groupId.setValue(res.groups.id, { emitEvent: false });
      this.groupCode.setValue(res.groups.code, { emitEvent: false });
      this.entityGroupId = res.groups.id;
      this.isExistingGroup = true;
    } else {
      this.entityGroupId = null;
      this.isExistingGroup = false;
    }
    this.creditComponent.creditTermForm.patchValue(res, { emitEvent: false });
    this.creditComponent.syncCurrencyNames();
    if (res.customerFlag) {
      this.creditComponent.showCustomerFields = true;
      this.creditComponent.setCustomerValidators();
    } else {
      this.creditComponent.showCustomerFields = false;
      this.creditComponent.clearCustomerValidators();
    }
    if (res.vendorFlag) {
      this.creditComponent.showVendorFields = true;
      this.creditComponent.setVendorValidators();
    } else {
      this.creditComponent.showVendorFields = false;
      this.creditComponent.clearVendorValidators();
    }
    // if(res?.address?.stateId)
    //   setTimeout(() => {
    //     this.addressComponent?.address?.patchValue({...res?.address, cityId:res?.address?.cityId,
    //       stateId:res?.address?.stateId || []    
    //     });
    //     this.entityForm?.patchValue({...res,
    //       address: {...res?.address, cityId:res?.address?.cityId,
    //         stateId:res?.address?.stateId || []    
    //       }
    //     });
    //   }, 2000);

    this.getEmails().clear();
    if (res.email && res.email.length > 0) {
      res.email.forEach(email => {
        this.getEmails().push(
          this.formBuilder.control(email, [
            Validators.required,
            Validators.pattern(this.emailPattern)
          ])
        );
      });
    }
   }

  disableForm(res){
    const deactivationPending = res.status === 'APPROVED' && res.submittedForApproval
      && !!res.deactivateDtls?.deactivationWefDate;
    if (this.isViewMode || res.status == "DEACTIVATED" || (res.submittedForApproval && !deactivationPending)) {
      this.disableSubmit = true;
      this.entityForm.disable({ emitEvent: false });
      this.creditComponent?.creditTermForm?.disable({ emitEvent: false });
      this.addressComponent?.address?.disable({ emitEvent: false });
    }
  }

  getEmails(): FormArray {
  return this.email as FormArray;
}

removeEmail(index: number) {
  this.getEmails().removeAt(index);
  this.entityForm.markAsDirty();
}


addEmails(event: MatChipInputEvent) {
  const value = (event.value || '').trim();
 const emailArray = this.getEmails();
  this.duplicateEmailError = null;

  if (!value) {
    if (event.input) event.input.value = '';
    return;
  }


   if (value.length > 100) {
    const invalidControl = this.formBuilder.control(value, [
      Validators.required,
      Validators.pattern(this.emailPattern),
      Validators.maxLength(100)
    ]);
    invalidControl.markAsTouched();
    emailArray.push(invalidControl);
    if (event.input) event.input.value = '';
    return;
  }

 if (emailArray.controls.some(control => 
      control.value.toLowerCase() === value.toLowerCase())) {
    this.duplicateEmailError = 'Duplicate email not allowed: ' + value;
    if (event.input) event.input.value = '';
    return;
  }

  const emailControl = this.formBuilder.control(value, [
    Validators.required,
    Validators.pattern(this.emailPattern),
    Validators.maxLength(100)
  ]);
   emailArray.push(emailControl);
  if (!emailControl.valid) {
    emailControl.markAsTouched();
  }
  this.entityForm.markAsDirty();

  if (event.input) event.input.value = '';
  
}

validateEmailOnBlur(index: number) {
  const emailControl = this.getEmails().at(index);
  emailControl.markAsTouched();
}

  private getStatus(data: any) {
    if (data.status == "APPROVED" && !data.submittedForApproval) {
      this.showDeactivateToggle=true;
      return null;
    }
    else if (data.status == "DEACTIVATED" && !data.submittedForApproval) {
      this.showReactivateToggle=true;
      return "Deactivated...";
    } else {
      return this.utilityService.getApprovalMessage({status:data.status,
        submittedForApproval: data.submittedForApproval,
        deactivationWefDate: data.deactivateDtls?.deactivationWefDate,
        reactivationWefDate: data.reactivateDtls?.reactivationWefDate});
    }
  }

  private openDailog(message?:string){
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });

    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else {
          if(!this.isEditedData) {
            this.router.navigate([APP_ROUTES.ENTITY_LIST]);
          }
          else {
            this.saveEntity();
          }
        }
    })
  }

  resetTDSValues(){
    this.tdsExemptionWefDate.reset();
    this.tdsExemptionValidUptoDate.reset();
    this.tdsExemptionPercentage.reset();
  }

  getNameErrorMessage(){
    return this.name.hasError('required') ? 'Entity Name is required' :
           this.name.hasError('maxlength') ? 'Entity Name should not be more than 60 characters' :''
  }

  getLandlineErrorMessage(){
    return this.landlineNo.hasError('pattern') ? 'Landline Number should be in proper format & only numbers (max 20 characters)' :''
  }

  getTdsDocument(res:any){
    // Prefer the dedicated fields populated by the backend; fall back to filtering entityDocuments
    // for backward compatibility with older API responses.
    if (res?.tdsDocument?.fileName) {
      this.tdsDocument = res.tdsDocument;
      this.fileName = this.tdsDocument?.originalFileName;
    } else {
      const filtered = (res?.entityDocuments || []).filter((item: any) => item.name === 'TDS');
      if (filtered.length > 0) {
        this.tdsDocument = filtered.reduce((prev: any, current: any) => (prev.id > current.id ? prev : current));
        this.fileName = this.tdsDocument?.originalFileName;
      }
    }
    if (res?.logoDocument?.fileName) {
      this.logoDocument = res.logoDocument;
      this.logoFileName = this.logoDocument?.originalFileName || '';
    } else {
      const logoFiltered = (res?.entityDocuments || []).filter((item: any) =>
        item.code === 'ENTITY_LOGO' || item.type === 'Entity_Logo' || item.type === 'LOGO' || item.name === 'Entity Company Logo'
      );
      if (logoFiltered.length > 0) {
        this.logoDocument = logoFiltered.reduce((prev: any, current: any) => (prev.id > current.id ? prev : current));
        this.logoFileName = this.logoDocument?.originalFileName || '';
      }
    }
  }

  previewLogoFile() {
    if (this.logoFile instanceof File) {
      this.openDocPreview(this.logoFile, this.logoFile.name, this.logoFile.type);
      return;
    }
    if (this.logoDocument?.fileName) {
      this.service.donwload(this.logoDocument.fileName).subscribe((data: Blob) => {
        if (data) {
          this.openDocPreview(data, this.logoDocument.originalFileName,
            this.getDocMimeType(this.logoDocument.originalFileName));
        }
      });
    }
  }

  downloadLogo() {
    if (this.logoFile instanceof File) {
      this.triggerDocDownload(this.logoFile, this.logoFile.name);
      return;
    }
    if (this.logoDocument?.fileName) {
      this.service.donwload(this.logoDocument.fileName).subscribe((data: Blob) => {
        if (data) {
          this.triggerDocDownload(data, this.logoDocument.originalFileName || 'logo');
        }
      });
    }
  }

  getCompanyTypes(){
    this.service.get(Api.COMPANY_TYPES_LIST).subscribe(res => {
      this.companyTypes=res;
      this.filteredCompanyType.next(this.companyTypes);
      this.setCountryValueChangeEvent();
    })
  }

  getEntityLevelList(){
    this.service.get(Api.ENTITY_LEVEL_LIST).subscribe(res => {
      this.entityLevelList=res;
    })
  }

  getDomicileTypes(){
    this.service.get(Api.DOMICILE_TYPES_LIST).subscribe(res => {
      this.domicileTypes=res;
    })
  }

  getGstTypes(){
    this.service.get(Api.ENTITY_TYPE_LIST).subscribe(res => {
      this.gstTypes=res;
    })
  }

  getFilter() {
    this.typeSearchCtrl.valueChanges.pipe(tap(() => this.searching = true),
      takeUntil(this.onDestroy),
        debounceTime(200),
        map(value => {
          if (!this.currencyList) { return []; }
          if(!value) { this.filtered.next(this.currencyList); }
          return this.currencyList.filter(origin => origin.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
        }),
        delay(500)
      )
      .subscribe(filter => {
        this.searching = false;
        this.filtered.next(filter);
      },
      error => { this.searching = false; });
  }

  getCurrenyList(){
    this.service.get(Api.CURRENCY_FOR_DD).subscribe(res => {
      this.currencyList=res;
      this.filtered.next(this.currencyList);
    })
  }


  getEntityGroupList(){
    this.service.get(Api.ENTITY_GROUP_LIST).subscribe(res => {
      if(res){
        this.logger.info("Entity group list", res);
        this.entityGroupList=res;
        this.filteredGroup.next(this.entityGroupList);
      }
    })
  }

  refreshEntityGroupList(): void {
    this.service.get(Api.ENTITY_GROUP_LIST).subscribe(res => {
      if (res) {
        this.entityGroupList = res;
        const currentSearch = this.groupName?.value || '';
        const s = currentSearch.toLowerCase();
        const filtered = s
          ? this.entityGroupList.filter((g: any) =>
              g?.name?.toLowerCase().includes(s) || g?.code?.toLowerCase().includes(s))
          : this.entityGroupList;
        this.filteredGroup.next(filtered);
      }
    });
  }

  ngAfterViewInit(): void {
    this.addressComponent.address.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(val => { this.entityBranch1Address = { ...val }; });
  }

  ngAfterViewChecked(){
    if(this.addressComponent?.address?.dirty || this.creditComponent?.creditTermForm?.dirty){
      this.entityForm.markAsDirty();
    }
    this.changerDetectorRef.detectChanges();
  }

  getSalesList(){
    this.service.get(Api.EMPLOYEE_FOR_DD, { 'active.equals': true, departmentType: 'Sales' }).subscribe(res => {
      this.salesPersonList=res;
      this.filteredSalesPerson.next(this.salesPersonList);
    })
  }

  getCustomerList(){
    this.service.get(Api.EMPLOYEE_FOR_DD, { 'active.equals': true, departmentType: 'Customer Service' }).subscribe(res => {
      this.customerList=res;
      this.filteredCustomer.next(this.customerList);
    })
  }

  getDialCodes() {
    this.service.get(Api.EXTERNAL_ENTITY_DIAL_CODES).subscribe(res => {
      if (res) {
        this.allDialCodes = Object.entries(res).map(([dialCode, countryName]) => ({
          dialCode,
          countryName: countryName as string
        }));
        this.filteredDialCodes$.next([...this.allDialCodes]);
      }
    });
  }



  displayDialCode(dialCode: string): string {
    if (!dialCode) return '';
    const found = this.allDialCodes?.find(item => item.dialCode === dialCode);
    return found ? `${found.countryName} (${found.dialCode})` : dialCode;
  }


   onSelectChange(event: Event): void {
    this.selectedDialCode = (event.target as HTMLSelectElement).value;
    this.dialCodeSelected.emit(this.selectedDialCode!); // Emit the selected string dial code
  }

  filterSalesPerson() {
    this.salesPersonSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.salesPersonList) { return []; }
          if(!search) { this.filteredSalesPerson.next(this.salesPersonList); }
          return this.salesPersonList.filter(origin => origin.name.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(200)
      )
      .subscribe(filteredSalesPerson => {
        this.searching = false;
        this.filteredSalesPerson.next(filteredSalesPerson);
      },
      error => { this.searching = false; });
  }

  filterCustomer() {
    this.customerSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.customerList) { return []; }
          if(!search) { this.filteredCustomer.next(this.customerList); }
          return this.customerList.filter(customer => customer.name.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(200)
      )
      .subscribe(filteredCustomer => {
        this.searching = false;
        this.filteredCustomer.next(filteredCustomer);
      },
      error => { this.searching = false; });
  }

  filterCompanyTypes(){
     this.companySearchCtrl.valueChanges.pipe(
      tap(() => this.searching = true),
      takeUntil(this.onDestroy),
      debounceTime(200),
      map(search => {
        if (!this.companyTypes) { return []; }
        if(!search) { this.filteredCompanyType.next(this.companyTypes); }
        return this.companyTypes.filter(types => types.label.toLowerCase().indexOf(search.toLowerCase()) > -1);
      }),
      delay(200)
    )
    .subscribe(filteredTypes => {
      this.searching = false;
      this.filteredCompanyType.next(filteredTypes);
    },
    error => { this.searching = false; });
  }

  addGroupDetail(){
      // When an existing group is already linked, pre-fill the dialog with that
      // group's id/code/name so the user renames it in-place rather than creating
      // a new record. Fall back to the newGroupDetail draft for a brand-new group.
      const dialogData = this.groupId.value ? this.group.value : this.newGroupDetail.value;
      const dailogRef=this.dailog.open(GroupDetailFormComponent,{
        data: dialogData
      });

      dailogRef.afterClosed().subscribe(dailogResult => {
        this.logger.info('External Entity group in',dailogResult);
          if(!dailogResult){
            this.newGroupName.setValue(null);
            return;
          }
          this.newGroupDetail.patchValue(dailogResult);
      })
  }

  getSaveDisableCondn(){
    if(this.disableSubmit || (!this.editPermission && this.id.value) || (!this.addPermission && !this.id.value)){
      return false;
    }
    if (this.entityId && this.status.value !== 'DRAFT' && !this.hasUnsavedChanges()) {
      return false;
    }
    return true;
  }

  // ngA(): void {
  //   if(this.addressComponent.address.dirty){
  //     this.entityForm.markAsDirty();
  //   }  
  //   // this.address=this.addressComponent.address.value;
  // }

  getSalesCordinatorList(){
    this.service.get(Api.EMPLOYEE_FOR_DD, { 'active.equals': true, departmentType: 'Sales' }).subscribe(res => {
      this.salesCoOrdinatorList=res;
      this.filteredSalesCordinator.next(this.salesCoOrdinatorList);
      this.salesSupportList=res;
      this.filteredSalesSupport.next(this.salesSupportList);
    })
  }

  filterSalesCoOrdinator() {
    this.salesCoOrdinatorSearchCtrl.valueChanges.pipe(
      tap(() => this.searching = true),
      takeUntil(this.onDestroy),
      debounceTime(200),
      map(search => {
        if (!this.salesCoOrdinatorList) { return []; }
        if (!search) { this.filteredSalesCordinator.next(this.salesCoOrdinatorList); }
        return this.salesCoOrdinatorList.filter(origin => origin.name.toLowerCase().indexOf(search.toLowerCase()) > -1);
      }),
      delay(200)
    )
      .subscribe(filteredSalesCordinator => {
        this.searching = false;
        this.filteredSalesCordinator.next(filteredSalesCordinator);
      },
        error => { this.searching = false; });
  }

  filterSalesSupport() {
    this.salesSupportSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.salesSupportList) { return []; }
          if(!search) { this.filteredSalesSupport.next(this.salesSupportList); }
          return this.salesSupportList.filter(origin => origin.name.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(200)
      )
      .subscribe(filteredSalesSupport => {
        this.searching = false;
        this.filteredSalesSupport.next(filteredSalesSupport);
      },
      error => { this.searching = false; });
  }

  getTrackerList(){
    this.service.get(Api.EMPLOYEE_FOR_DD, { 'active.equals': true, departmentType: 'Customer Service' }).subscribe(res => {
      this.trackerList=res;
      this.filteredTracker.next(this.trackerList);
    })
  }
  
  filtertracker() {
    this.trackerSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.trackerList) { return []; }
          if(!search) { this.filteredTracker.next(this.trackerList); }
          return this.trackerList.filter(customer => customer.name.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(200)
      )
      .subscribe(filteredTracker => {
        this.searching = false;
        this.filteredTracker.next(filteredTracker);
      },
      error => { this.searching = false; });
}



  private formatPhoneNumberForDisplay(number: string): string {
    if (!number) return '';
    if (number.startsWith('+')) {
      const countryCode = number.match(/^\+\d{1,3}/)?.[0] || '';
      const rest = number.slice(countryCode.length).replace(/\D/g, '');
      return `${countryCode} ${rest.match(/.{1,4}/g)?.join(' ') || ''}`.trim();
    }

    return number.replace(/\D/g, '').match(/.{1,4}/g)?.join(' ') || number;
  }


  addPhoneNumber(event: MatChipInputEvent): void {
    const input = event.input;
    let numberValue = event.value;

    const currentDialCode = this.selectedDialCode;

    if (!currentDialCode) {
      this.utilityService.toastrErrorMessage(Message.SELECT_COUNTRY_CODE_FIRST);
      if (input) { input.value = ''; }
      return;
    }

    if ((numberValue || '').trim()) {
      numberValue = numberValue.trim();
      const newCellNumberGroup = this.formBuilder.group({
        dialCode: [currentDialCode, Validators.required],
        number: [numberValue, [Validators.required, this.validateSinglePhoneNumber()]]
      });
      newCellNumberGroup.get('number').updateValueAndValidity();
      newCellNumberGroup.get('dialCode').updateValueAndValidity();

      if (newCellNumberGroup.valid) {
        const isDuplicate = this.cellNumberDetails.controls.some(control => {
          const existingDialCode = control.get('dialCode')?.value;
          const existingNumber = control.get('number')?.value;
          return existingDialCode === currentDialCode && existingNumber === numberValue;
        });

        if (!isDuplicate) {
          this.cellNumberDetails.push(newCellNumberGroup);
          this.entityForm.markAsDirty();
        } else {
          this.utilityService.toastrErrorMessage(Message.DIAL_CODE_NUMBER_DUPLICATE);
        }
      } else {
        if (newCellNumberGroup.get('number')?.hasError('invalidCharacters')) {
          this.utilityService.toastrErrorMessage(Message.PHONE_INVALID_CHARS);
        } else if (newCellNumberGroup.get('number')?.hasError('maxLength')) {
          this.utilityService.notifier(Message.PHONE_MAX_15_DIGITS, 'warning');
        } else {
          this.utilityService.toastrErrorMessage(Message.PHONE_INVALID_FORMAT);
        }
      }
    }
    if (input) {
      input.value = '';
    }
  }

  isChipInvalid(numberControl: AbstractControl): boolean {
    return numberControl.invalid && (numberControl.touched || this.entityForm.touched);
  }



  validateSinglePhoneNumber() {
    return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    if (!value) { return null; }
    const numberPattern = /^[\d()\s\-+]+$/;
    if (!numberPattern.test(value)) {
      return { invalidCharacters: true };
    }
    return null;
  };
  }


  validateCellNumberDetails() {
    return (formArray: AbstractControl): { [key: string]: any } | null => {
      if (!(formArray instanceof FormArray)) {
        return null;
      }
      const invalidEntries: string[] = [];
      formArray.controls.forEach((group: AbstractControl) => {
        const dialCodeControl = group.get('dialCode');
        const numberControl = group.get('number');

        const dialCode = dialCodeControl?.value;
        const number = numberControl?.value;
        if (!dialCode || !number) {
          invalidEntries.push(`Incomplete entry: ${dialCode || ''}${number || ''}`);
        } else {
          const singleNumberValidationResult = this.validateSinglePhoneNumber()(numberControl);
          if (singleNumberValidationResult) {
            if (singleNumberValidationResult['invalidCharacters']) {
              invalidEntries.push(`Invalid chars in '${dialCode} ${number}'`);
            } else if (singleNumberValidationResult['maxLength']) {
              invalidEntries.push(`Length > 15 for '${dialCode} ${number}'`);
            }
          }
        }
      });

      return invalidEntries.length > 0 ? { invalidNumbers: invalidEntries } : null;
    };
  }


  removePhoneNumber(index: number): void {
    if (index >= 0) {
      this.cellNumberDetails.removeAt(index);
      this.entityForm.markAsDirty();
    }
  }

  onPhoneKeyDown(event: KeyboardEvent): void {
    if (!this.selectedDialCode) {
    event.preventDefault();
    this.utilityService.toastrErrorMessage('Please select a Country Code first.');
    return;
  }
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', ' ', '-', '(', ')'];
  const isDigit = /[0-9]/.test(event.key);
  const input = event.target as HTMLInputElement;
  const currentValue = input.value || '';
  const dialCode = this.selectedDialCode || '';
  const totalLength = (dialCode + currentValue).length;
    if (totalLength >= 15 && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(event.key)) {
    event.preventDefault();
    this.utilityService.notifier(Message.PHONE_MAX_15_DIGITS, 'info');
    return;
  }

  if (!allowedKeys.includes(event.key) && !isDigit) {
    event.preventDefault();
  }
  }


  onCountrySelected(dialCode: string) {
    this.selectedDialCode = dialCode;
    this.dialCodeSelected.emit(dialCode);
    setTimeout(() => {
      const phoneInput = document.getElementById('phoneInput') as HTMLInputElement;
      phoneInput?.focus();
    }, 0);
  }

  clearSearch() {
    this.dialCodeSearchCtrl.setValue('');
    this.selectedDialCode = '';
    this.dialCodeSelected.emit('');
  }

  filterDialCodes(searchTerm?: string) {
    if (!this.allDialCodes) return;

    const term = (searchTerm || '').toLowerCase().trim();

    if (!term) {
      this.filteredDialCodes$.next([...this.allDialCodes]);
      return;
    }

    const filtered = this.allDialCodes.filter(
      item =>
        item.countryName.toLowerCase().includes(term) ||
        item.dialCode.toLowerCase().includes(term)
    );

    this.filteredDialCodes$.next(filtered);
  }



  setupDialCodeSearch() {
    this.filteredDialCodes$.next([]);
    this.dialCodeSearchCtrl.valueChanges
      .pipe(
        takeUntil(this.onDestroy),
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(searchTerm => {
        this.filterDialCodes(searchTerm);
      });
    this.getDialCodes();
  }

  public getAllPermissions(){
    let permissionCodes=[PermissionKey.EXTERNAL_ENTITY_REACTIVATE_PERMISSION,PermissionKey.EXTERNAL_ENTITY_DEACTIVATE_PERMISSION,PermissionKey.EXTERNAL_ENTITY_EDIT_PERMISSION,PermissionKey.EXTERNAL_ENTITY_ADD_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.ENTITY_MODULE);
    this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.EXTERNAL_ENTITY_REACTIVATE_PERMISSION})?.show?true:false;
    this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.EXTERNAL_ENTITY_DEACTIVATE_PERMISSION})?.show?true:false;
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.EXTERNAL_ENTITY_EDIT_PERMISSION})?.show?true:false;
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.EXTERNAL_ENTITY_ADD_PERMISSION})?.show?true:false;
  }

  // Keyed by the real nested Java field name on the DTO (the segment right after the
  // referenceType in propertyName, e.g. "EXTERNAL_ENTITY.groups.name" → "groups") —
  // NOT the backend's Auditable.Module enum name, which never appears in nested paths.
  private readonly auditPrefixLabels: { [key: string]: string } = {
    'groups': 'Group',
    'taxDetialsDto': 'Branch GST',
    'contactDetailsDto': 'Branch Contact',
    'contactDetails': 'Branch Contact',
    'currency': 'Currency of Transaction'
  };

  private readonly auditFieldLabels: { [key: string]: string } = {
    'name': 'Name',
    'code': 'Code',
    'legalName': 'Legal Name',
    'keyPersonName': 'Key Person Name',
    'externalEntityAlias': 'Entity Alias',
    'alias': 'Alias',
    'email': 'Email',
    'landlineNo': 'Landline No.',
    'companyType': 'Company Type',
    'salesPersonId': 'Sales Person',
    'customerSupportId': 'Customer Support',
    'salesSupportId': 'Sales Support',
    'isLegalNameSameAsName': 'Legal Name Same as Name',
    'entityDetails': 'Entity Business Type',
    'companyLogoPath': 'Company Logo',
    'status': 'Status',
    // Address sub-fields
    'address': 'Address',
    'cityName': 'City',
    'stateName': 'State',
    'countryName': 'Country',
    'landMarkSet': 'Landmarks',
    // Deactivation / Reactivation sub-fields
    'deactivationWefDate': 'Deactivation WEF Date',
    'deactivatedDate': 'Deactivated Date',
    'deactivationReason': 'Deactivation Reason',
    'reactivationWefDate': 'Reactivation WEF Date',
    'reactivatedDate': 'Reactivated Date',
    'reactivationReason': 'Reactivation Reason',
    // Tax & Credit Details tab fields
    'domicile': 'Domicile Type',
    'gstType': 'Entity GST Type',
    'gstNo': 'GST No',
    'panNoTaxId': 'PAN No. / Income Tax No',
    'tdsExemption': 'TDS Exemption',
    'tdsExemptionWefDate': 'Exemption WEF',
    'tdsExemptionValidUptoDate': 'Exemption Upto',
    'tdsExemptionPercentage': 'TDS Exemption %age',
    'tdsExemptionCertificatePath': 'TDS Exemption Certificate',
    'entityCriteria': 'Entity Business Relationship',
    'chargeMechanismType': 'Charge Mechanism Type',
    'customerFlag': 'Customer',
    'customerEntityLevel': 'Customer Entity Level',
    'customerCreditDays': 'Customer Credit Days',
    'customerCreditAmount': 'Customer Credit Amount',
    'customerApprovalStatus': 'Customer Approval Status',
    'vendorFlag': 'Vendor',
    'vendorEntityLevel': 'Vendor Entity Level',
    'vendorCreditDays': 'Vendor Credit Days',
    'vendorCreditAmount': 'Vendor Credit Amount',
    'vendorApprovalStatus': 'Vendor Approval Status',
    // Branch fields
    'branchType': 'Branch Type',
    'pincode': 'ZIP / PIN Code',
    'creditDays': 'Credit Days',
    'creditAmount': 'Credit Amount',
    // Branch Contact fields
    'cellNumber': 'Mobile Number',
    'businessSegmentName': 'Business Segment',
    'departmentName': 'Department',
    'designationName': 'Designation',
    'displayNameForMobileApp': 'Display Name for Mobile Application'
  };

  // Flat fields (no prefix) that belong to the Tax & Credit Details tab.
  // These must be excluded from Entity Details and included in processTaxCreditRecords.
  private readonly TAX_CREDIT_FLAT_FIELDS = new Set([
    // Tax section
    'domicile', 'gstType', 'gstNo', 'panNoTaxId',
    'tdsExemption', 'tdsExemptionWefDate', 'tdsExemptionValidUptoDate',
    'tdsExemptionPercentage', 'tdsExemptionCertificatePath',
    'chargeMechanismType',
    // Credit section
    'entityCriteria',
    'customerFlag', 'customerEntityLevel', 'customerCreditDays', 'customerCreditAmount', 'customerApprovalStatus', 'customerCategory',
    'vendorFlag', 'vendorEntityLevel', 'vendorCreditDays', 'vendorCreditAmount', 'vendorApprovalStatus', 'vendorCategory',
  ]);

  // Nested-object prefixes (parts[1] of the property name) that belong to Tax & Credit Details.
  // currency is a nested CurrencyDTO stored as currency.id / currency.name etc.
  private readonly TAX_CREDIT_PREFIXES = new Set(['currency']);

  private isTaxCreditField(propertyName: string): boolean {
    if (!propertyName) { return false; }
    const prefix = this.getAuditPrefix(propertyName);
    if (prefix !== '') { return this.TAX_CREDIT_PREFIXES.has(prefix); }
    const parts = propertyName.split('.');
    return this.TAX_CREDIT_FLAT_FIELDS.has(parts[parts.length - 1]);
  }

  // Fields that must never appear in any audit tab — checked against both raw field
  // name (last segment of dotted path) and pre-translated label from audit_property_key.
  private readonly AUDIT_HIDDEN_FIELDS = new Set([
    'id', 'activeFlag', 'submittedForApproval', '_rowNo', // raw camelCase field names
    'Id', 'Active', 'Submitted for Approval'              // pre-translated labels
  ]);

  private isAuditHidden(propertyName: string): boolean {
    const field = propertyName.split('.').pop() ?? '';
    return this.AUDIT_HIDDEN_FIELDS.has(propertyName) || this.AUDIT_HIDDEN_FIELDS.has(field);
  }

  private readonly GROUP_HIDDEN_FIELDS = new Set(['serialVersionUID', 'id', 'companyId', 'clientId']);

  processEntityRecords = (items: any[]): any[] => {
    const filtered = (items || [])
      .filter(item => {
        const pn = item.propertyName;
        if (this.isAuditHidden(pn)) { return false; }
        if (this.BACKEND_GROUP_LABELS.has(pn)) { return false; }
        if (this.BACKEND_TAX_CREDIT_LABELS.has(pn)) { return false; }
        if (this.BACKEND_KYC_RENAMED_LABELS.has(pn)) { return false; }
        const prefix = this.getAuditPrefix(pn);
        const field = pn.split('.').pop();
        if (prefix === 'groups' || prefix === 'entityDocuments'
            || prefix === 'logoDocument' || prefix === 'tdsDocument'
            || prefix === 'branchDetails') { return false; }
        if (this.isTaxCreditField(pn)) { return false; }
        if (field === 'displayNameForMobileApp') { return false; }
        // For alias sub-fields, only show 'name' (hides referenceName/referenceId/clientId/companyId noise)
        if (prefix === 'externalEntityAlias' && field !== 'name') { return false; }
        // For phone sub-fields, only show dialCode + number (hide any other fields)
        if (prefix === 'cellNumberDetails' && field !== 'dialCode' && field !== 'number') { return false; }
        return true;
      });

    // Split phone items from the rest so we can merge dialCode+number into one "Mobile No." row
    const phoneItems = filtered.filter(item => this.getAuditPrefix(item.propertyName) === 'cellNumberDetails');
    const rest      = filtered.filter(item => this.getAuditPrefix(item.propertyName) !== 'cellNumberDetails');

    // Group by the composite key (3rd dot-segment: e.g. "+91_9876543210")
    const phoneGroups = new Map<string, { dialCode?: any; number?: any }>();
    phoneItems.forEach(item => {
      const parts = item.propertyName.split('.');
      const groupKey = parts.length >= 3 ? parts[2] : parts[1];
      if (!phoneGroups.has(groupKey)) { phoneGroups.set(groupKey, {}); }
      const entry = phoneGroups.get(groupKey)!;
      const field = parts[parts.length - 1];
      if (field === 'dialCode') { entry.dialCode = item; }
      else if (field === 'number') { entry.number = item; }
    });

    const mergedPhoneItems: any[] = [];
    phoneGroups.forEach(entry => {
      const combine = (d: string, n: string) => {
        const dc  = (d  && d  !== 'null') ? d  : '';
        const num = (n  && n  !== 'null') ? n  : '';
        return [dc, num].filter(Boolean).join(' ') || null;
      };
      mergedPhoneItems.push({
        propertyName: 'Mobile No.',
        oldValue: combine(entry.dialCode?.oldValue, entry.number?.oldValue),
        newValue: combine(entry.dialCode?.newValue, entry.number?.newValue)
      });
    });

    return [
      ...rest.map(item => {
        const prefix = this.getAuditPrefix(item.propertyName);
        const field  = item.propertyName.split('.').pop();
        // Alias 'name' sub-field → render with a clean "Entity Alias" label
        if (prefix === 'externalEntityAlias' && field === 'name') {
          return { ...item, propertyName: 'Entity Alias' };
        }
        // entityDetails stores comma-separated raw EntityType enum names → convert to labels
        if (field === 'entityDetails') {
          return {
            ...item,
            propertyName: this.resolveAuditLabel(item.propertyName),
            oldValue: this.formatEntityTypeValues(item.oldValue),
            newValue: this.formatEntityTypeValues(item.newValue)
          };
        }
        return { ...item, propertyName: this.resolveAuditLabel(item.propertyName) };
      }),
      ...mergedPhoneItems
    ];
  };

  private formatEntityTypeValues(value: string): string {
    if (!value || value === 'null') { return value; }
    return value.split(',')
      .map(v => this.ENTITY_TYPE_LABELS[v.trim()] ?? v.trim())
      .join(', ');
  }

  processEntityGroupRecords = (items: any[]): any[] => {
    return (items || [])
      .filter(item => {
        const pn = item.propertyName;
        if (this.isAuditHidden(pn)) { return false; }
        // Pre-translated by backend
        if (this.BACKEND_GROUP_LABELS.has(pn)) { return true; }
        // Raw-path routing
        const prefix = this.getAuditPrefix(pn);
        const field = pn.split('.').pop();
        if (prefix === 'groups') { return !this.GROUP_HIDDEN_FIELDS.has(field); }
        if (prefix === 'logoDocument') { return !this.TDS_LOGO_HIDDEN_FIELDS.has(field); }
        return field === 'displayNameForMobileApp';
      })
      .map(item => {
        const prefix = this.getAuditPrefix(item.propertyName);
        const field = item.propertyName.split('.').pop();
        if (prefix === 'logoDocument') {
          const isUpload = this.ENTITY_KYC_UPLOAD_FIELDS.has(field);
          return {
            ...item,
            propertyName: this.ENTITY_KYC_FIELD_LABELS[field] || this.humanizeAuditField(field),
            oldValue: isUpload ? this.toKycUploadedLabel(item.oldValue) : item.oldValue,
            newValue: isUpload ? this.toKycUploadedLabel(item.newValue) : item.newValue
          };
        }
        return { ...item, propertyName: this.resolveAuditLabel(item.propertyName) };
      });
  };

  processTaxCreditRecords = (items: any[]): any[] => {
    return (items || [])
      .filter(item => {
        if (this.isAuditHidden(item.propertyName)) { return false; }
        if (this.BACKEND_TAX_CREDIT_LABELS.has(item.propertyName)) { return true; }
        if (this.isTaxCreditField(item.propertyName)) { return true; }
        const prefix = this.getAuditPrefix(item.propertyName);
        const field = item.propertyName.split('.').pop();
        return prefix === 'tdsDocument' && !this.TDS_LOGO_HIDDEN_FIELDS.has(field);
      })
      .map(item => {
        const prefix = this.getAuditPrefix(item.propertyName);
        const field = item.propertyName.split('.').pop();
        if (prefix === 'tdsDocument') {
          const isUpload = this.ENTITY_KYC_UPLOAD_FIELDS.has(field);
          return {
            ...item,
            propertyName: this.ENTITY_KYC_FIELD_LABELS[field] || this.humanizeAuditField(field),
            oldValue: isUpload ? this.toKycUploadedLabel(item.oldValue) : item.oldValue,
            newValue: isUpload ? this.toKycUploadedLabel(item.newValue) : item.newValue
          };
        }
        return { ...item, propertyName: this.resolveAuditLabel(item.propertyName) };
      });
  };

  // Backend sends some sections (Group/Tax & Credit/KYC) with propertyName already set to
  // its final human-readable label via audit_property_key (e.g. "GST No.", "PAN No. / Tax Id").
  // Those labels can contain literal periods, which getAuditFieldLabel's dot-path parsing
  // would otherwise mistake for path separators and mangle (e.g. "GST No." -> "", "PAN No. /
  // Tax Id" -> "/ Tax Id"). Pass pre-translated labels through untouched instead.
  private isBackendPretranslatedLabel(propertyName: string): boolean {
    return this.BACKEND_GROUP_LABELS.has(propertyName)
      || this.BACKEND_TAX_CREDIT_LABELS.has(propertyName)
      || this.BACKEND_KYC_RENAMED_LABELS.has(propertyName);
  }

  private resolveAuditLabel(propertyName: string): string {
    return this.isBackendPretranslatedLabel(propertyName) ? propertyName : this.getAuditFieldLabel(propertyName);
  }

  // Backend-internal fields on DocumentDownloadDTO that must never reach the audit UI.
  private readonly KYC_INTERNAL_FIELDS = new Set(['id', 'referenceId', 'referenceName', 'type']);

  // Additional fields to suppress for tdsDocument / logoDocument only.
  // uploadedBy / uploadedOn are KYC-workflow metadata — relevant for the KYC Details tab
  // (entityDocuments) but irrelevant for a TDS certificate or a company logo document.
  private readonly TDS_LOGO_HIDDEN_FIELDS = new Set([
    ...Array.from(this.KYC_INTERNAL_FIELDS), 'uploadedBy', 'uploadedOn', 'fileName'
  ]);

  // Pre-translated labels sent by the backend (via audit_property_key) for Group Details items.
  private readonly BACKEND_GROUP_LABELS = new Set([
    'Group Name', 'Group Code',
    'Display Name for Mobile Application'
  ]);

  // Pre-translated labels sent by the backend for Tax & Credit Details items.
  private readonly BACKEND_TAX_CREDIT_LABELS = new Set([
    'Domicile Type', 'GST Type', 'GST No.', 'PAN No. / Tax Id', 'Entity Business Relationship',
    'TDS Exemption', 'Exemption WEF', 'Exemption Upto', 'TDS Exemption %', 'TDS Exemption Certificate',
    'Charge Mechanism Type',
    'Customer', 'Customer Entity Level', 'Customer Credit Days', 'Customer Credit Amount', 'Customer Approval Status', 'Customer Category',
    'Vendor', 'Vendor Entity Level', 'Vendor Credit Days', 'Vendor Credit Amount', 'Vendor Approval Status', 'Vendor Category'
  ]);

  // Human-friendly labels that the backend may have already applied via audit_property_key.
  // Items arriving with these as their propertyName bypass the prefix-based filter.
  private readonly BACKEND_KYC_RENAMED_LABELS = new Set(['Document Code', 'Document Name', 'Upload', 'KYC Done By', 'KYC Date & Time']);

  // Entity KYC Details: entityDocuments on the ExternalEntity itself.
  private readonly ENTITY_KYC_FLAT         = new Set(['entityDocuments']);
  private readonly ENTITY_KYC_UPLOAD_FIELDS = new Set<string>(['originalFileName']);
  private readonly ENTITY_KYC_FIELD_LABELS: { [key: string]: string } = {
    code: 'Document Code',
    name: 'Document Name',
    originalFileName: 'File Uploaded',
    uploadedBy: 'KYC Done By',
    uploadedOn: 'KYC Date & Time',
  };

  /** True when propertyName is a 2-part flat key (idOnly collection) whose field segment is in fieldSet. */
  private isBranchFlatCollection(propertyName: string, fieldSet: Set<string>): boolean {
    if (!propertyName) { return false; }
    const parts = propertyName.split('.');
    return parts.length === 2 && fieldSet.has(parts[1]);
  }

  // Entity KYC Details: documents attached directly to the ExternalEntity record.
  // Uploaded-file fields show as Yes/No rather than the raw file name/path.
  processEntityKycRecords = (items: any[]): any[] => {
    return (items || [])
      .filter(item => {
        // If backend already renamed via audit_property_key, accept the item directly.
        if (this.BACKEND_KYC_RENAMED_LABELS.has(item.propertyName)) { return true; }
        const prefix = this.getAuditPrefix(item.propertyName);
        if (prefix !== '') { return prefix === 'entityDocuments'; }
        return this.isBranchFlatCollection(item.propertyName, this.ENTITY_KYC_FLAT);
      })
      .filter(item => !this.KYC_INTERNAL_FIELDS.has(item.propertyName.split('.').pop())
                   && item.propertyName.split('.').pop() !== 'fileName')
      .map(item => {
        // Already renamed by backend — rename 'Upload' to 'File Uploaded' and pass value through.
        if (this.BACKEND_KYC_RENAMED_LABELS.has(item.propertyName)) {
          if (item.propertyName === 'Upload') {
            return { ...item, propertyName: 'File Uploaded' };
          }
          return item;
        }
        const parts = item.propertyName.split('.');
        const field = parts[parts.length - 1];
        const isFlat = this.isBranchFlatCollection(item.propertyName, this.ENTITY_KYC_FLAT);
        const isUploadField = isFlat || this.ENTITY_KYC_UPLOAD_FIELDS.has(field);
        return {
          ...item,
          propertyName: isFlat ? 'File Uploaded' : (this.ENTITY_KYC_FIELD_LABELS[field] || this.humanizeAuditField(field)),
          oldValue: isUploadField ? this.toKycUploadedLabel(item.oldValue) : item.oldValue,
          newValue: isUploadField ? this.toKycUploadedLabel(item.newValue) : item.newValue
        };
      });
  };

  private toKycUploadedLabel(value: any): string {
    if (value === null || value === undefined) { return 'No'; }
    return String(value).trim().length > 0 ? 'Yes' : 'No';
  }

  private filterAuditItemsByPrefix(items: any[], prefixes: string[]): any[] {
    return (items || [])
      .filter(item => prefixes.includes(this.getAuditPrefix(item.propertyName)))
      .map(item => ({ ...item, propertyName: this.getAuditFieldLabel(item.propertyName) }));
  }

  private filterAuditItemsExcludingPrefix(items: any[], excludedPrefixes: string[]): any[] {
    return (items || [])
      .filter(item => !excludedPrefixes.includes(this.getAuditPrefix(item.propertyName)))
      .map(item => ({ ...item, propertyName: this.getAuditFieldLabel(item.propertyName) }));
  }

  private getAuditPrefix(propertyName: string): string {
    if (!propertyName) { return ''; }
    const parts = propertyName.split('.');
    // parts[0] is always the referenceType itself (e.g. EXTERNAL_ENTITY) — the real
    // section name, if this property is nested, is the segment right after it.
    return parts.length > 2 ? parts[1] : '';
  }

  private getAuditFieldLabel(propertyName: string): string {
    if (!propertyName) { return ''; }
    const parts = propertyName.split('.');
    const field = parts[parts.length - 1];
    const prefix = this.getAuditPrefix(propertyName);
    // currency is a nested DTO — all sub-fields (id, name, code) represent a single
    // "Currency of Transaction" change, so collapse them to one label.
    if (prefix === 'currency') { return 'Currency of Transaction'; }
    const fieldLabel = this.auditFieldLabels[field] || this.humanizeAuditField(field);
    const prefixLabel = this.auditPrefixLabels[prefix];
    return prefixLabel ? `${prefixLabel} ${fieldLabel}` : fieldLabel;
  }

  private humanizeAuditField(field: string): string {
    return field
      .replace(/([A-Z])/g, ' $1')
      .replace(/[_.]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, c => c.toUpperCase());
  }

  get id(){return this.entityForm.get('id');}
  get code(){return this.entityForm.get('code');}
  get name(){return this.entityForm.get('name');}
  get externalEntityAlias(){return <FormArray>this.entityForm.get('externalEntityAlias');}
  get legalName(){return this.entityForm.get('legalName');}
  get keyPersonName(){return this.entityForm.get('keyPersonName');}
  get email(){return <FormArray>this.entityForm.get('email');}
  get cellNumberDetails(): FormArray { return this.entityForm.get('cellNumberDetails') as FormArray; }
  get landlineNo(){return this.entityForm.get('landlineNo');}
  get companyType(){return this.entityForm.get('companyType');}
  get domicile(){return this.entityForm.get('domicile');}
  get gstType(){return this.entityForm.get('gstType');}
  get panNoTaxId(){return this.entityForm.get('panNoTaxId');}
  get gstNo(){return this.entityForm.get('gstNo');}
  get entityCriteria(){return this.entityForm.get('entityCriteria');}
  get groupId(){return this.entityForm.get('groups.id');}
  get groupCode(){return this.entityForm.get('groups.code');}
  get groupName(){return this.entityForm.get('groups.name');}
  get groupDisplayName(){return this.entityForm.get('displayNameForMobileApp');}
  get group(){return this.entityForm.get('groups');}
  get newGroupName(){return this.entityForm.get('newGroupDetail.name');}
  get newGroupDetail(){return this.entityForm.get('newGroupDetail');}
  get submittedForApproval(){return this.entityForm.get('submittedForApproval');}
  get externalDetails(){return (<FormArray> this.entityForm.get('externalDetails'));}
  get entityDetails(){return <FormArray>this.entityForm.get('entityDetails');}
  get tdsExemptionPercentage(){return this.entityForm.get('tdsExemptionPercentage');}
  get tdsExemption(){return this.entityForm.get('tdsExemption');}
  get tdsExemptionWefDate(){return this.entityForm.get('tdsExemptionWefDate');}
  get tdsExemptionValidUptoDate(){return this.entityForm.get('tdsExemptionValidUptoDate');}
  get address(){return this.entityForm.get('address');}
  get countryId(){return this.addressComponent?.address?.get('countryId');}
  set address(address){ this.entityForm.get('address').patchValue(address); }
  set customerFlag(customerFlag){this.entityForm.get('customerFlag').setValue(customerFlag);}
  set customerEntityLevel(customerEntityLevel){this.entityForm.get('customerEntityLevel').setValue(customerEntityLevel);}
  set customerCreditDays(customerCreditDays){this.entityForm.get('customerCreditDays').setValue(customerCreditDays);}
  set customerCreditAmount(customerCreditAmount){this.entityForm.get('customerCreditAmount').setValue(customerCreditAmount);}
  set customerApprovalStatus(customerApprovalStatus){this.entityForm.get('customerApprovalStatus').setValue(customerApprovalStatus);}//
  set vendorFlag(vendorFlag){this.entityForm.get('vendorFlag').setValue(vendorFlag);}
  set vendorEntityLevel(vendorEntityLevel){this.entityForm.get('vendorEntityLevel').setValue(vendorEntityLevel);}
  set vendorCreditDays(vendorCreditDays){this.entityForm.get('vendorCreditDays').setValue(vendorCreditDays);}
  set vendorCreditAmount(vendorCreditAmount){this.entityForm.get('vendorCreditAmount').setValue(vendorCreditAmount);}
  set vendorApprovalStatus(vendorApprovalStatus){this.entityForm.get('vendorApprovalStatus').setValue(vendorApprovalStatus);}//
  set customerCategory(val){this.entityForm.get('customerCategory').setValue(val);}
  set vendorCategory(val){this.entityForm.get('vendorCategory').setValue(val);}
  set customerCurrencyId(val){this.entityForm.get('customerCurrencyId').setValue(val);}
  set vendorCurrencyId(val){this.entityForm.get('vendorCurrencyId').setValue(val);}
  get status(){ return this.entityForm.get('status');}
  get salesPersonId(){return this.entityForm.get('salesPersonId');}
  get customerSupportId(){return this.entityForm.get('customerSupportId');}
  get salesCoOrdinatorId(){return this.entityForm.get('salesCoOrdinatorId');}
  get salesSupportId(){return this.entityForm.get('salesSupportId');}
  get TrackerId(){return this.entityForm.get('TrackerId');}
  get chargeMechanismType(){return this.entityForm.get('chargeMechanismType');}
  get currencyName(){return this.entityForm.get('currencyName');}
}
